import { useQuery } from '@tanstack/react-query';
import { getModelCatalog } from '@/api/llm';
import { cloudApi, cloudBillingApi } from '@/api/cloud';

const isDesktop = !!window.psbDesktop?.isDesktop;

/**
 * 模型 id → 展示名：剥 platform: 前缀，本地目录→云端目录查目录名，
 * 查不到回退裸 id。平台模型不再以 `platform:opencode-xxx` 形式出现在 UI。
 */
export function useModelDisplayName(modelId?: string): string {
  const bare = modelId?.startsWith('platform:') ? modelId.slice('platform:'.length) : modelId;

  const { data: catalog } = useQuery({
    queryKey: ['llmModelCatalog'],
    queryFn: getModelCatalog,
    staleTime: 5 * 60 * 1000,
  });
  const { data: cloudStatus } = useQuery({
    queryKey: ['cloudStatus'],
    queryFn: cloudApi.getStatus,
    enabled: isDesktop,
    staleTime: 30000,
  });
  const { data: cloudCatalog } = useQuery({
    queryKey: ['cloudModelCatalog'],
    queryFn: cloudBillingApi.catalog,
    enabled: isDesktop && !!cloudStatus?.bound,
    staleTime: 5 * 60 * 1000,
  });

  if (!bare) return '';
  return (
    catalog?.models.find((m) => m.id === bare)?.name ||
    cloudCatalog?.models.find((m) => m.id === bare)?.name ||
    bare
  );
}
